import * as validators from "@vuelidate/validators";

export const customValidators = () => {
  const { $i18n } = useNuxtApp();
  const { createI18nMessage } = validators;
  const withI18nMessage = createI18nMessage({ t: $i18n.t.bind($i18n) });

  return {
    alpha: withI18nMessage(validators.alpha),
    alphaNum: withI18nMessage(validators.alphaNum),
    between: withI18nMessage(validators.between, { withArguments: true }),
    decimal: withI18nMessage(validators.decimal),
    email: withI18nMessage(validators.email),
    integer: withI18nMessage(validators.integer),
    ipAddress: withI18nMessage(validators.ipAddress),
    macAddress: withI18nMessage(validators.macAddress),
    maxLength: withI18nMessage(validators.maxLength, { withArguments: true }),
    minLength: withI18nMessage(validators.minLength, { withArguments: true }),
    minValue: withI18nMessage(validators.minValue, { withArguments: true }),
    maxValue: withI18nMessage(validators.maxValue, { withArguments: true }),
    not: withI18nMessage(validators.not, { withArguments: true }),
    numeric: withI18nMessage(validators.numeric),
    or: withI18nMessage(validators.or, { withArguments: true }),
    required: withI18nMessage(validators.required),
    requiredIf: withI18nMessage(validators.requiredIf, { withArguments: true }),
    requiredUnless: withI18nMessage(validators.requiredUnless, {
      withArguments: true,
    }),
    sameAs: withI18nMessage(validators.sameAs, { withArguments: true }),
    url: withI18nMessage(validators.url),
    maxFilesize: withI18nMessage(maxFilesize, { withArguments: true }),
    fileTypeAllowed: withI18nMessage(fileTypeAllowed, { withArguments: true }),
  };
};

export const maxFilesize = (maxSize: number) => {
  return validators.helpers.withMessage(
    () => {
      const maxMB = (maxSize / (1024 * 1024)).toFixed(1);
      console.log(maxMB);
      return `File must be between 1 and ${maxMB} MB.`;
    },
    validators.helpers.withParams(
      {
        type: "maxFilesize",
        maxSize,
        maxMB: (maxSize / (1024 * 1024)).toFixed(1),
      },
      (value: File | null) => {
        if (!value) return true;
        const size = value.size;
        return size <= maxSize;
      }
    )
  );
};

export const fileTypeAllowed = (allowedTypes: string[]) => {
  return validators.helpers.withMessage(
    () => {
      return `Only these file types are allowed: ${allowedTypes.join(", ")}`;
    },
    validators.helpers.withParams(
      {
        type: "fileTypeAllowed",
        allowedTypes,
        allowedTypesString: allowedTypes.join(", "),
      },
      (value: File | null) => {
        if (!value) return true;
        return allowedTypes.includes(value.type);
      }
    )
  );
};
